class AccountLogin extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.customerLogedIn = this.dataset.customer === "true";
    this.COUNTRY_CODE = this.dataset.country;
  }

  connectedCallback() {
    this.initClickEvents();
    this.initInputEvents();
    this.initSubmitEvents();
    this.returnToElement = this.querySelector("input[name='return_url']");
    this.registerLinkElement = this.querySelector("#account_register_url");
    this.initUpdateRegisterUrl();
  }
  initUpdateRegisterUrl() {
    if (this.registerLinkElement) {
      const params = new URLSearchParams(window.location.search);
      const returnUrl =
        params.get("return_to") || params.get("checkout_url") || "";
      const registerUrl = this.registerLinkElement.href;

      if (returnUrl.includes("checkout") && this.COUNTRY_CODE === "JP")
        this.registerLinkElement.href = `${registerUrl}?return_to=/cart?checkout=true`;
    }
  }

  validateFields(form) {
    if (!form) return false;

    let validationResult = false;

    if (form.id === "LoginForm") {
      validationResult = this.validateLoginFields(form);
    } else if (form.id === "RecoveryForm") {
      validationResult = this.validateRecoveryFields(form);
    }
    return validationResult;
  }

  validateLoginFields(form) {
    if (!form) return false;
    let hasNoErrors = true;

    form.querySelectorAll("[data-field]").forEach((field) => {
      const input = field.querySelector("input");
      const errorField = field.querySelector("[data-field-error]");

      if (input.name == "customer[email]") {
        if (!input.value.trim()) {
          errorField.innerText = window.authorizationStrings.email_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.authorizationStrings.email;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "customer[password]") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.authorizationStrings.password_login_empty;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      }
    });

    return hasNoErrors;
  }

  validateRecoveryFields(form) {
    if (!form) return false;
    let hasNoErrors = true;

    form.querySelectorAll("[data-field]").forEach((field) => {
      const input = field.querySelector("input");
      const errorField = field.querySelector("[data-field-error]");

      if (input.name == "email") {
        if (!input.value.trim()) {
          errorField.innerText = window.authorizationStrings.email_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.authorizationStrings.email;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      }
    });

    return hasNoErrors;
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "open-recovery":
            if (this.querySelector("#RecoveryForm")) {
              this.querySelector("[data-popup]").classList.add("open");
            }
            break;
          case "close-recovery":
            this.querySelector("[data-popup]").classList.remove("open");
            break;
        }
      } else if (e.target.hasAttribute("data-field-show")) {
        const field = e.target.closest("[data-field]");
        field.classList.toggle("show-pass");
        field.querySelector("input").type = field.classList.contains(
          "show-pass",
        )
          ? "text"
          : "password";
      }
    });

    document.addEventListener("click", (e) => {
      this.querySelectorAll("[data-field-select]").forEach((select) => {
        if (select !== e.target.closest("[data-field-select]")) {
          select.classList.remove("open");
        }
      });
    });
  }

  initInputEvents() {
    this.addEventListener("input", (e) => {
      this.validateFields(e.target.closest("form"));
    });
  }

  initSubmitEvents() {
    const formList = this.querySelectorAll("form");

    formList.forEach((form) => {
      form
        .querySelector('button[type="submit"]')
        .addEventListener("click", (e) => {
          e.preventDefault();

          if (this.validateFields(form)) {
            if (form.id === "LoginForm") {
              const params = new URLSearchParams(window.location.search);
              let returnUrl =
                params.get("checkout_url") ||
                params.get("return_to") ||
                params.get("return_url") ||
                null;

              if (returnUrl) {
                this.returnToElement.value = returnUrl;
              }
            }

            form.submit();
          }
        });
    });
  }
}

customElements.define("account-login", AccountLogin);
